<template>
  <template v-if="expand.show">
    <div class="box" :class="type">
      <div class="box_swiper">
        <Swiper class="box_carousel" :autoHeight="true" loop :autoplay="{delay:30000,disableOnInteraction:false,pauseOnMouseEnter:true}"
          :keyboard="{enabled:true,onlyInViewport:true}" :slidesPerView="1" :speed="600"
          :navigation="{prevEl:' .button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}" :pagination="{clickable:true}">
          <SwiperSlide v-for="item in expand.bannerList" :key="item.id">
            <div class="box_panel box_panel_bg box_text" :class="{isDetail}"
              :style="{'--title_light':`${rgba(item.title_light||'#ffffff',0.8)}`,'--content_light':`${rgba(item.content_light||'#ffffff',0.8)}`}">
              <i class="box_bg" :style="{'background-image':`url(${item.bg_image})`}"></i>
              <a-row type="flex" class="box_row" :style="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?'':{'flex-direction': 'column'}">
                <a-col flex="1 1 auto">
                  <a-typography>
                    <a-typography-title :level="5">
                      <div class="title_html" v-html="item.title"></div>
                    </a-typography-title>
                    <a-typography-paragraph :style="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?{'font-size': '14px','line-height': '21px'}:''">
                      <div class="title_html" v-html="item.content"></div>
                    </a-typography-paragraph>
                  </a-typography>
                </a-col>
                <a-col :flex="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?'0 0 260px':''"
                  :style="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)?'':{'justify-content': 'center',width:'100%','margin-top': '10px'}">
                  <a-button type="link" class="button" :style="{'background-color':`${item.button_bg_color} !important`,'color':`${item.button_text_color} !important`}"
                    @click="clickButton(item)">
                    <p v-html="item.button_text"></p>
                  </a-button>
                </a-col>
              </a-row>
            </div>
          </SwiperSlide>
        </Swiper>
        <!-- <template v-if="expand.bannerList.length > 1"> -->
        <a-button type="link" class="button_prev" :style="{display:expand.bannerList.length > 1?'block':'none'}">
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
        <a-button type="link" class="button_next" :style="{display:expand.bannerList.length > 1?'block':'none'}">
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
        <!-- </template> -->
      </div>
    </div>
    <!--<div class="box_panel box_video">-->
    <!--    <video ref="video"-->
    <!--           :src="href.video" :poster="file.ImageVideoCover"-->
    <!--           controls preload />-->
    <!--</div>-->
  </template>
</template>

<script lang="ts">
import { DataInterface } from "@interface/public";
import { AxiosBannerList } from "@server/apiBanner";
import SwiperCore, { Autoplay, Keyboard, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { LeftOutlined, RightOutlined } from "@ant-design/icons-vue";

export default {
  name: "platform_introduction",
  props: ["isDetail",'type'],
  components: {
    Swiper,
    SwiperSlide,
    LeftOutlined,
    RightOutlined,
  },
  beforeCreate(): void {
    SwiperCore.use([Navigation, Autoplay, Keyboard]);
  },
  data(): DataInterface {
    return {
      href: {
        novice: "https://mp.weixin.qq.com/s/yD2Yy_o7PL7oG07GGW-TpA",
        video:
          "https://img2.galaxy-future.com/apps/video/gfappsdescription.mp4",
        whitebook:
          "https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd",
        whitebookWC:
          "https://img2.galaxy-future.com/files/%E6%98%9F%E6%B1%89%E6%9C%AA%E6%9D%A5AI%E5%BA%94%E7%94%A8%E5%B9%B3%E5%8F%B0%28AIPilot%29%E7%A4%BE%E5%8C%BA%E7%89%88%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf",
      },
      file: {},
      expand: {
        show: true,
        bannerList: [],
      },
    };
  },
  mounted(): void {
    this.getBanner();
  },
  methods: {
    rgba(hex: string, alpha: any) {
      // 如果是 hex 颜色格式 (#RRGGBB)
      if (/^#([0-9A-Fa-f]{3}){1,2}$/.test(hex)) {
        let r, g, b;
        if (hex.length === 4) {
          // #RGB 格式
          r = parseInt(hex[1] + hex[1], 16);
          g = parseInt(hex[2] + hex[2], 16);
          b = parseInt(hex[3] + hex[3], 16);
        } else {
          // #RRGGBB 格式
          r = parseInt(hex[1] + hex[2], 16);
          g = parseInt(hex[3] + hex[4], 16);
          b = parseInt(hex[5] + hex[6], 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }
      return hex; // 如果不是 hex 格式，则返回原始颜色
    },
    /**
     * 点击了解
     */
    clickButton(item: any): void {
      // $FN.Agent.client() === 'PC' && $Store.Public().isGridMatch('>', $Enum.GridEnum.MD)
      //   ? $Store.Platform().openModal('modalNovice')
      //   : this.$router.push($Enum.RouterEnum.Novice);
      // this.$router.push($Enum.RouterEnum.PlatformPlan);
      // open(!$Store.Public().isChannelWeChat() ? this.href.whitebookWC : this.href.whitebook);
      // open(`https://gcom-aibot.oss-cn-beijing.aliyuncs.com/apk_download/xhwl_released_1.0.4_34.apk`);
      open(item.button_url);
    },
    getBanner(): void {
      AxiosBannerList({}).then((res) => {
        const data = res.data;
        if (data.code !== $Enum.CodeEnum.Normal) return;
        this.expand.bannerList = data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "@resource/css/_global.less";

@imagePublic: "@{src_image}platform/public/";
.box_carousel {
  height: max-content;
  border-radius: 6px;
  display: flex;
  align-items: center;
  &:deep(.swiper-wrapper) {
    align-items: center;
  }
  &:deep(.swiper-pagination) {
    display: none !important;
  }
}
.box{
  background-color: #000430;
  display: flex;
  align-items: center;
  justify-content: center;
  &.overseas{
    background-color: transparent;
    .box_swiper{
      // padding: 6px 12px 6px 12px;
      margin: 6px 12px 6px 0;
    }
  }
}
.box_swiper {
  max-width: 1200px;
  margin: 6px 12px;
  // margin: 0 auto;
  background-color: transparent;
  &:hover {
    .button_prev,
    .button_next {
      opacity: 1;
    }
  }
}
.button_next,
.button_prev {
  @wh: 30px;
  width: @wh !important;
  height: @wh !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  bottom: auto !important;
  opacity: 0;
  transition: all 0.3s;
}
.button_next {
  right: 6px;
}
.button_prev {
  left: 6px;
}
.box_panel_bg.box_panel {
  padding: 0;
  margin: 0 !important;
}
.box_bg {
  position: absolute;
  border-radius: 6px;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.box_panel.box_text {
  height: 100%;
  .box_row {
    height: 100%;
  }
  &:deep(.ant-row) {
    padding: 20px 20px 20px 40px;
    border-radius: 5px;
    overflow: hidden;
  }
  position: relative;
  // padding: 20px 20px 20px 40px;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: inherit; /* 继承背景图 */
    z-index: -1; /* 保证背景层在内容层下 */
  }

  &.isDetail {
    margin: 10px 20px !important;
  }

  .ant-row {
    flex-wrap: nowrap;

    .ant-col {
      &:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .title_html {
    &:deep(p) {
      margin-bottom: 0;
      &::selection {
        text-shadow: none;
      }
    }
  }

  article.ant-typography {
    h5.ant-typography {
      margin: 0;
      .font(left, 24px, @color_black, 22px, true);
      @text_border: var(--title_light, #ffffff);
      @shadow_color: var(--title_light, #ffffff);
      @shadow: 10px;
      @text_wh: 4px;
      @text_shadow: 6px;
      @shadow_wh: 4px;
      text-shadow: @text_wh @text_wh @text_shadow @text_border,
        -@text_wh -@text_wh @text_shadow @text_border,
        @text_wh -@text_wh @text_shadow @text_border,
        -@text_wh @text_wh @text_shadow @text_border,
        @shadow_wh @shadow_wh @shadow @shadow_color,
        -@shadow_wh -@shadow_wh @shadow @shadow_color,
        @shadow_wh -@shadow_wh @shadow @shadow_color,
        -@shadow_wh @shadow_wh @shadow @shadow_color;
      &::selection {
        text-shadow: none;
      }
    }

    div.ant-typography {
      margin: 10px 0 0;
      max-width: max-content;
      .font(justify, @font_7+4px, #153564, @font_7);
      letter-spacing: 1px;
      &::selection {
        text-shadow: none;
      }
      @shadow: 8px;
      @text_border: var(--content_light, #ffffff);
      @shadow_color: var(--content_light, #ffffff);
      @text_wh: 1px;
      @shadow_wh: 2px;
      text-shadow: @text_wh @text_wh 0 @text_border,
        -@text_wh -@text_wh 0 @text_border, @text_wh -@text_wh 0 @text_border,
        -@text_wh @text_wh 0 @text_border,
        @shadow_wh @shadow_wh @shadow @shadow_color,
        -@shadow_wh -@shadow_wh @shadow @shadow_color,
        @shadow_wh -@shadow_wh @shadow @shadow_color,
        -@shadow_wh @shadow_wh @shadow @shadow_color;
    }

    .ant-btn {
      height: auto;
      padding: 0;
      .font(justify, @font_6+4px, @color_white, @font_6);
      .transition(opacity @time);

      &:hover {
        opacity: 0.85;
      }
    }
  }

  .button {
    @h: 34px;
    width: max-content !important;
    background: @color_15 !important;
    .font(center, -1px+@h, @color_8, 18px, true) !important;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 0 16px !important;
    border-radius: 16px !important;
    height: max-content !important;
  }
}

.box_video {
  position: relative;
  padding: 0 20px;

  video {
    display: block;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    border-radius: @radius;
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_panel.box_text {
    .ant-row {
      .ant-col {
        &:nth-child(2) {
          justify-content: right;
        }
      }
    }

    article.ant-typography {
      h5.ant-typography {
        .font(left, @font_6+2px, @color_black, @font_6, true);
      }

      div.ant-typography {
        .font(left, @font_8+4px, #153564, @font_8);
      }

      .ant-btn {
        .font(left, @font_8+4px, @color_white, @font_8);
      }
    }

    .button {
      @h: 30px;
      width: max-content !important;
      height: @h !important;
      border-radius: @h*0.5 !important;
      .font(center, -2px+@h, @color_8, @font_8, true) !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .box_panel.box_text {
    background-size: cover;
  }
}
</style>